
import React from "react";
import { useState, useEffect, useRef} from 'react';
import styles from './header.module.css';
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import Avatar from '@mui/material/Avatar';
import { useAuth } from '../../global_state_components/AuthProvider.jsx';
import { BsList } from "react-icons/bs";
import { GrUpgrade } from "react-icons/gr";

import { useGlobalState } from '../../global_state_components/GlobalStateProvider.jsx';
import { axiosInstance, axiosInstanceForImage } from "../../../lib/axiosInstance.js";

import ProfilePicDropDown from "../../miscellaneous/ProfilePicDropDown/ProfilePicDropDown.jsx";


function Header(props){
  const { isAuthenticated, setIsAuthenticated} = useAuth();    //Defined in AuthProvider.jsx

  const {profilePicRef, isMobile, isSaved, showProfilePicDropDown, setShowProfilePicDropDown } = useGlobalState();

  const navigate = useNavigate();    //Use the useNavigate hook to programmatically navigate to another route in response to an event (like a button click).

  //src={`${process.env.REACT_APP_BASE_URL}/api/profile/image?type=profile`}
  const [profilePic, setProfilePic] = useState("/images/blank_profile_picture.webp"||null);

  useEffect(() => {
    const fetchProfilePic = async () => {
      try {
        const response = await axiosInstanceForImage.get('/profile/image?type=profile');
        const imageUrl = URL.createObjectURL(response.data);
        //console.log("response.data : " + response.data);
        setProfilePic(imageUrl);
      } catch (error) {
        console.error('Error fetching profile pic:', error);
      }
    }
    fetchProfilePic();
  },[isSaved]);



  function handleProfilePicDropDown(event){
    //event.stopPropagation(); // Prevent click event from propagating to the document-level handler
    setShowProfilePicDropDown(prev => !prev); // Toggle the dropdown
    //console.log("header showProfilePicDropDown : "+showProfilePicDropDown);
  }


  
  return (
    <div className={styles.header_div}>
      {
        (isMobile)&&(
          <button onClick={props.toggleSidePanel} className={styles.mobile_side_panel_listings_button}>
            <BsList className={styles.mobile_side_panel_listings_icon}/>
          </button>
        )
      }

      {/* <h1 className={styles.header}>Discusslearn</h1> */}
      {/* <p className={styles.nameplate}><span className= {styles.discuss}>Discuss</span><span className= {styles.learn}>learn</span></p> */}
      <p className={styles.nameplate}><span className= {styles.discuss}>Discuss</span><span className= {styles.learn}>learn</span></p>
    
      {/* Main search bar */}
      {/* 
      <div className={styles.main_search}>
        <input className={styles.main_searh_input} placeholder="What do you want to learn ?"></input>
        <div className={styles.main_search_icon}>
          <CiSearch/>
        </div>
      </div>     
      */}

      {
        (isAuthenticated==='authenticated') && (isMobile?(
          <Link to="/upgrade" className={styles.mobile_upgrade_button}>
            <GrUpgrade/>
          </Link>
          ):(
          <Link to="/upgrade" className={styles.upgrade_button}>     {/*To redirect without giving a seperate onClick function.*/}   
            Upgrade
          </Link>
          )
        )
      }

  
      {/* <div className='cfdal_person_details_div'><Avatar className={styles.avatar_class" alt="Paul" src='/images/paul.jpg'/></div> */}
      {/*<Avatar className={styles.avatar_class} alt="Paul" src='/images/paul.jpg'/>*/}

      {
        (showProfilePicDropDown===true)&&(<ProfilePicDropDown/>)
      }

      {
        (isAuthenticated==='authenticated')&&(
          <img onClick={handleProfilePicDropDown} ref={profilePicRef} className={styles.avatar_class} alt="Paul" src={profilePic}/>
        )
      }
    
    </div>
  )
}

export default Header;













// //------------------------------------------------------------------------------------










// import React from "react";
// import styles from '../../css/matrix_page_main_components/header.module.css';
// // import '../../css/matrix_page_main_components/header.module.css';


// import { useNavigate } from 'react-router-dom';
// import { Link } from "react-router-dom";
// import Avatar from '@mui/material/Avatar';
// import { useAuth } from '../AuthProvider';
// import { BsList } from "react-icons/bs";
// import { GrUpgrade } from "react-icons/gr";

// import { useGlobalState } from '../GlobalStateProvider.jsx';


// function Header(props){
//   const { isAuthenticated, logout } = useAuth();    //Defined in AuthProvider.jsx

//   const {isMobile} = useGlobalState();

//   const navigate = useNavigate();    //Use the useNavigate hook to programmatically navigate to another route in response to an event (like a button click).

//   //Code from chatGPT below. 
//   const handleLogout = async () => {
//     try {
//       /*
//       const token = localStorage.getItem('token');       // or get it from cookies
//       console.log("ttttttttttttt :"+token);
      
//       await axiosInstance.get('/auth/logout', {}, {
//         headers: {
//           'Authorization': `Bearer ${token}`
//         }
//       });
//       */
      

//       // Remove the token from localStorage
//       //----localStorage.removeItem('token');

//       // Redirect to login or home page
//       logout();     //isAuthenticated is made "false".    //token is made "null".
//       console.log("isAuthenticated in the logging out : "+ isAuthenticated);
//       localStorage.setItem('category', 'silent_study');
//       navigate('/');
//     } catch (error) {
//       console.error('Error logging out:', error);
//     }
//   };
  

//   return (
//     <div className={styles{styles.header_div}>
//       <button onClick={props.toggleSidePanel} className={styles{styles.mobile_side_panel_listings_button}>
//         <BsList className={styles.mobile_side_panel_listings_icon"/>
//       </button>

//       {/* <h1 className={styles.header">Discusslearn</h1> */}
//       {/* <p className={styles.nameplate"><span className= {styles.discuss">Discuss</span><span className= {styles.learn">learn</span></p> */}
//       <p className={styles{styles.nameplate}><span className= {styles{styles.discuss}>Discuss</span><span className= {styles{styles.learn}>learn</span></p>
    
//       {/* Main search bar */}
//       {/* 
//       <div className={styles.main_search'>
//         <input className={styles.main_sear{styles.input' placeholder="What do you want to learn ?"></input>
//         <div className={styles.main_sear{styles.icon'>
//           <CiSearch/>
//         </div>
//       </div>     
//       */}

//       {isMobile?
//         (
//           <GrUpgrade onClick={handleLogout} className={styles{styles.mobile_upgrade_button} />
//         ):(
//           <Link onClick={handleLogout} className={styles{styles.upgrade_button} >     {/*to="/upgrade"*/} {/*To redirect without giving a seperate onClick function.*/}   
//             Logout               {/*Upgrade*/}
//           </Link>
//         )
//       }

  
//       {/* <div className='cfdal_person_details_div'><Avatar className={styles.avatar_class" alt="Paul" src='/images/paul.jpg'/></div> */}
//       {/*<Avatar className={styles.avatar_class" alt="Paul" src='/images/paul.jpg'/>*/}
//       <img className={styles{styles.avatar_class} alt="Paul" src='/images/paul.jpg'/>
    
//     </div>
//   )
// }

// export default Header;

